import React from "react";
import Fade from "react-reveal/Fade";

export default function Event() {
  return (
    <>
      {/* <Fade right cascade> */}
      <div className="container-content" style={{ padding: "40px 10px" }}>
        <p
          className="playball-font"
          style={{ fontSize: 23, color: "black", margin: "10px 0px 5px" }}
        >
          Rangkaian Acara
        </p>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            style={{
              height: 1,
              width: 50,
              backgroundColor: "#cc9933",
              marginTop: 10,
            }}
          />
          <p
            className="dancing-font"
            style={{
              fontSize: 24,
              color: "#cc9933",
              margin: "10px 12px 5px",
            }}
          >
            Akad Nikah
          </p>
          <div
            style={{
              height: 1,
              width: 50,
              backgroundColor: "#cc9933",
              marginTop: 10,
            }}
          />
        </div>
        <div
          style={{
            marginTop: 5,
            display: "flex",
            alignItems: "center",
            marginRight: "10px",
          }}
        >
          <div>
            <p
              className="josefin-font"
              style={{
                color: "black",
                fontWeight: "bolder",
                fontSize: 18,
                textAlign: "right",
                margin: 0,
              }}
            >
              Minggu
            </p>
            <p
              className="josefin-font"
              style={{
                color: "black",
                fontWeight: "normal",
                fontSize: 14,
                textAlign: "right",
                margin: 0,
                marginTop: 5,
              }}
            >
              08:00
            </p>
          </div>
          <div className="circle-date">
            <p>30</p>
          </div>
          <div>
            <p
              className="josefin-font"
              style={{
                color: "black",
                fontWeight: "bolder",
                fontSize: 18,
                textAlign: "left",
                margin: 0,
              }}
            >
              Januari
            </p>
            <p
              className="josefin-font"
              style={{
                color: "black",
                fontWeight: "normal",
                fontSize: 14,
                textAlign: "left",
                margin: 0,
                marginTop: 5,
              }}
            >
              2022
            </p>
          </div>
        </div>
        <p
          className="garamond-font"
          style={{
            fontSize: 16,
            color: "black",
            fontWeight: "bold",
            marginTop: 10,
            marginBottom: 30,
          }}
        >
          Golden City Ballroom
        </p>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            style={{
              height: 1,
              width: 50,
              backgroundColor: "#cc9933",
              marginTop: 10,
            }}
          />
          <p
            className="dancing-font"
            style={{
              fontSize: 24,
              color: "#cc9933",
              margin: "10px 12px 5px",
            }}
          >
            Resepsi
          </p>
          <div
            style={{
              height: 1,
              width: 50,
              backgroundColor: "#cc9933",
              marginTop: 10,
            }}
          />
        </div>
        <div
          style={{
            marginTop: 5,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginRight: "20px",
          }}
        >
          <div>
            <p
              className="josefin-font"
              style={{
                color: "black",
                fontWeight: "bolder",
                fontSize: 18,
                textAlign: "right",
                margin: 0,
              }}
            >
              Minggu
            </p>
            <p
              className="josefin-font"
              style={{
                color: "black",
                fontWeight: "normal",
                fontSize: 14,
                textAlign: "right",
                margin: 0,
                marginTop: 5,
              }}
            >
              10:00 - 13:00
            </p>
          </div>
          <div className="circle-date">
            <p>30</p>
          </div>
          <div>
            <p
              className="josefin-font"
              style={{
                color: "black",
                fontWeight: "bolder",
                fontSize: 18,
                textAlign: "left",
                margin: 0,
              }}
            >
              Januari
            </p>
            <p
              className="josefin-font"
              style={{
                color: "black",
                fontWeight: "normal",
                fontSize: 14,
                textAlign: "left",
                margin: 0,
                marginTop: 5,
              }}
            >
              2022
            </p>
          </div>
        </div>
        <p
          className="garamond-font"
          style={{
            fontSize: 16,
            color: "black",
            fontWeight: "bold",
            marginTop: 10,
          }}
        >
          Golden City Ballroom
        </p>
        <p
          className="garamond-font"
          style={{
            fontSize: 16,
            color: "black",
            margin: "10px 20px 0px",
          }}
        >
          Jl. KH Abdul Wahab Siamin Surabaya No.8, RW.2, Dukuh Pakis,
          Dukuhpakis, <br /> Kota Surabaya, Jawa Timur 60225
        </p>
      </div>
      {/* </Fade> */}
    </>
  );
}
